import { Component } from 'react'

export default function connectToStores(WrappedComponent) {
  return class StoreConnection extends Component {
    static displayName = 'Stateful' + (WrappedComponent.displayName || WrappedComponent.name || 'Container')

    static getDerivedStateFromProps(props) {
      return WrappedComponent.getPropsFromStores(props)
    }

    state = {}

    componentDidMount() {
      this.storeListeners = WrappedComponent
        .getStores(this.props)
        .map(store => store.listen(this.onStoreChange))
    }

    componentWillUnmount() {
      this.storeListeners.forEach(unlisten => unlisten())
    }

    onStoreChange = () => {
      this.setState({})
    }

    render() {
      return <WrappedComponent {...this.props} {...this.state} />
    }
  }
}
